import styled from 'styled-components';

export const TreatmentTabWrapper = styled.div`
  display: block;
`;
